import { FIELD_TYPES } from "constants/template-field-type";
export default {
    autoTransition: {
        type: FIELD_TYPES.TEXT,
        label: "Auto Transition (milliseconds)"
    }
};
